import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    marginLeft: '32px',
  },
  dropdownContainer: {
    maxWidth: 200,
    minWidth: 200,
  },
  dropdown: {
    maxHeight: 330,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
